export const GET_BIKES_REQUEST="GET_BIKES_REQUEST"
export const GET_BIKES_SUCCESS="GET_BIKES_SUCCSS"
export const GET_BIKES_FAILURE="GET_BIKES_FAILURE"
